import React from "react";
import {
  BaseModal,
  BaseModalBody,
  BaseModalHeader,
} from "@src/common/components";
import { PackageEventsContainer } from "./PackageEventsContainer";

interface PackageEventsModalProps {
  isOpen: boolean;
  onClose: () => void;
  shipmentId: string | null;
  orderDisplayId?: string | number;
}

export function PackageEventsModal({
  isOpen,
  onClose,
  shipmentId,
  orderDisplayId,
}: PackageEventsModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      overrides={{
        Dialog: {
          style: {
            width: "900px",
            maxWidth: "90vw",
          },
        },
      }}
    >
      <BaseModalHeader>
        Package Events{orderDisplayId ? ` - Order #${orderDisplayId}` : ""}
      </BaseModalHeader>
      <BaseModalBody>
        {shipmentId ? (
          <PackageEventsContainer shipmentId={shipmentId} />
        ) : (
          <div className="text-center text-gray-500 py-8">
            No shipment selected.
          </div>
        )}
      </BaseModalBody>
    </BaseModal>
  );
}

